import axios, {AxiosResponse} from 'axios'

const chatList = async (rec_id: string, model_type): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/chat/list/${rec_id}/${model_type}`)
  return response.data
}

const createChat = async ({data}) => {
  await axios.post('/api/chat/store', data)
}

const adminContacts = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/chat/admin-contacts/${id}`)
  return response.data
}

const userMsgCount = async () => {
  const response = await axios.get('/api/chat/user-msg-count')
  return response.data
}

const contactList = async () => {
  const response = await axios.get('/api/chat/contact-list')
  return response.data
}

const messageRead = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/chat/message-read/${id}`)
  return response.data
}

const studentContacts = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/chat/student-contacts/${id}`)
  return response.data
}

const lecturerContacts = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/chat/lecturer-contacts/${id}`)
  return response.data
}

const pendingMessages = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/chat/pending-message/${id}`)
  return response.data
}

const chatService = {
  pendingMessages,
  studentContacts,
  lecturerContacts,
  messageRead,
  contactList,
  userMsgCount,
  adminContacts,
  chatList,
  createChat,
}

export default chatService
